import React from 'react';
import CustomSwitch from '../../../../shared/CustomSwitch/CustomSwitch';
import CustomRadio from '../../../../shared/CustomRadioButton/CustomRadio';
import { ReactComponent as PaperLessIcon } from '../../../../assets/icons/paperless-v2.svg';
function InvoiceDelivery({ checked, onChange, hidden }) {
  return (
    <div
      className={`garden-wall-normal-card my-account-card ${hidden ? 'card-disabled' : ''}`}
    >
      <div className="title-row">
        <div className="section-title-my-account">Invoice delivery</div>
        <CustomSwitch
          checked={checked}
          onChange={onChange}
          size="small"
          color="var(--primary-color)"
        />
      </div>
      <div className="my-account-section-row">
        <div className="section-label">Billing Preferences</div>
        <div
          className="section-value"
          style={{ display: 'flex', flexDirection: 'column', gap: 15 }}
        >
          <div>
            <CustomRadio label="Paper Mail" onChange={() => {}} disabled />
          </div>
          <div>
            <CustomRadio
              label="Paperless Billing"
              onChange={() => {}}
              checked={true}
            />
          </div>
          <div className="paperless-card">
            <div>
              <PaperLessIcon />
            </div>
            <div className="paperless-content">
              <h6>Go Green - Receive bills electronically.</h6>
              <div className="paperless-content-description">
                Paperless billing offers convenience, security, and
                environmental benefits for both you and the company by
                eliminating paper waste and streamlining the billing process.
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default InvoiceDelivery;
